import { Dispatch, ReactNode } from 'react';
import { createContext } from 'react';
import type { useSortable } from '@dnd-kit/sortable';
import type { CSS as DndCSS } from '@dnd-kit/utilities';
export const DraggableContext = createContext<{
    useSortable: typeof useSortable | Dispatch<object>;
    DndCSS: typeof DndCSS | undefined;
    draggable: boolean;
    dragIcon: ReactNode;
    dragIconPosition: 'left' | 'right';
}>({
    useSortable: () => {},
    DndCSS: undefined,
    draggable: false,
    dragIcon: null,
    dragIconPosition: 'left',
});

export const HeaderRowContext = createContext<{
    isHeaderRow: boolean;
}>({
    isHeaderRow: false,
});
